import React from "react";

// Paginación compacta. Misma API de siempre: total, itemsPerPage, currentPage, onPageChange(page).
const PaginationComponent = ({
    total = 0,
    itemsPerPage = 10,
    currentPage = 1,
    onPageChange
}) => {
    const totalPages = total > 0 && itemsPerPage > 0 ? Math.ceil(total / itemsPerPage) : 0;

    if (totalPages === 0) return null;

    const desde = (currentPage - 1) * itemsPerPage + 1;
    const hasta = Math.min(currentPage * itemsPerPage, total);
    const fmt = (n) => new Intl.NumberFormat("en-US").format(n);

    return (
        <div className="dt-pager">
            <button
                type="button"
                className="btn dt-pager-btn"
                disabled={currentPage <= 1}
                onClick={() => onPageChange(currentPage - 1)}
                title="Anterior"
            >
                <i className="fas fa-chevron-left" />
            </button>
            <span className="dt-pager-info">
                Página <b>{currentPage}</b> de <b>{totalPages}</b>
            </span>
            <button
                type="button"
                className="btn dt-pager-btn"
                disabled={currentPage >= totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                title="Siguiente"
            >
                <i className="fas fa-chevron-right" />
            </button>
            <span className="dt-pager-total">
                {fmt(desde)}–{fmt(hasta)} de {fmt(total)}
            </span>
        </div>
    );
};

export default PaginationComponent;
